import axios from 'axios';

const version = 'v1';
const basePath = 'sorter-preparation-order';

export async function createForRetries({
  request_id,
  recipient,
  warehouse_id,
}) {
  return axios.request({
    url: `/${version}/${basePath}/retries/`,
    method: 'post',
    data: {
      recipient,
      request_id,
      warehouse_id,
    },
  });
}

export async function setAsWaiting(id) {
  return axios.request({
    url: `/${version}/${basePath}/${id}/set-as-waiting`,
    method: 'put',
  });
}
